    const eventEmitter = require("event-emitter");
    const FormHelper   = require("./FormHelper");

/* ======================================================================
	Generate Accept Token from Form
	===================================================================== */

    var AcceptTokenGenerator = function(clientKey, apiLoginID) {
        this.buildAuthData(clientKey, apiLoginID);
    }

    eventEmitter(AcceptTokenGenerator.prototype);

    AcceptTokenGenerator.prototype.formRoot = document;

    AcceptTokenGenerator.prototype.dataObj = {
        authData: {
            clientKey: "",
            apiLoginID: "",
        },
        cardData: {
            cardNumber: "",
            cardCode: "",
            month: "",
            year: "",
        }
    };


    AcceptTokenGenerator.prototype.buildAuthData = function(clientKey, apiLoginID) {
        this.dataObj.authData.clientKey  = clientKey;
        this.dataObj.authData.apiLoginID = apiLoginID;
    }


    AcceptTokenGenerator.prototype.buildCardData = function() {
        var formHelper = new  FormHelper(this.formRoot);

        for (const property in this.dataObj.cardData) {
            this.dataObj.cardData[property] = formHelper.getValueByAnetName(property);
        }
    }


    AcceptTokenGenerator.prototype.generateToken = function() {
        if (!this.validateObj(this.dataObj)) {
            throw 'Token could not be generated because not all data is available to be sent.';
        }

        Accept.dispatchData(this.dataObj, this.handleResponse.bind(this));
    }


    AcceptTokenGenerator.prototype.validateObj = function(object) {
        var isValid = true;

        for (const property in object) {
            isValid = this.validateProperty(object, property);
        }

        return isValid;
    }


    AcceptTokenGenerator.prototype.validateProperty = function(object, property) {
        if (object[property] === null) {
            return false;
        }

        if (typeof object[property] === 'object') {
            return this.validateObj(object[property]);
        }

        if (object[property] === "") {
            return false;
        }

        return true;
    }


    AcceptTokenGenerator.prototype.handleResponse = function(response) {
        if (response.messages.resultCode === "Error") {
            this.handleError(response);
        } else {
            this.emit("generatedToken", response);
            this.handleSuccess(response);
        }
    }


    AcceptTokenGenerator.prototype.handleError = function(response) {
        var messages = [];

        for (var i = 0; i < response.messages.message.length; i++) {
            messages.push(response.messages.message[i].code + ": " + response.messages.message[i].text);
        }
        console.log("should emit tokenGenerationFailed");


        this.emit("tokenGenerationFailed", messages.join("\n"));
    }

    AcceptTokenGenerator.prototype.handleSuccess = function(response) {

    }

    module.exports = AcceptTokenGenerator;
